deviceListener.$inject = ['DeviceService'];
function deviceListener(DeviceService) {
  DeviceService.mount();
}

export { deviceListener };
